export const MessagePosition = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
};

export default MessagePosition;
